var camel2hyphen = function (str) {
  return str.replace(/[A-Z]/g, function (match) {
    return '-' + match.toLowerCase();
  }).toLowerCase();
};
var camel2hyphen_1 = camel2hyphen;
export { camel2hyphen_1 as default };
//# sourceMappingURL=camel2hyphen.js.map
